// Class: openfl.display.IGraphicsFill

var $global = typeof window != "undefined" ? window : typeof global != "undefined" ? global : typeof self != "undefined" ? self : this

$global.Object.defineProperty(exports, "__esModule", {value: true});

var __map_reserved = {};

// Imports

var $hxClasses = require("./../../hxClasses_stub").default;
var $hxEnums = require("./../../hxEnums_stub").default;

// Constructor

var IGraphicsFill = function() {}

// Meta

IGraphicsFill.__name__ = "openfl.display.IGraphicsFill";
IGraphicsFill.__isInterface__ = true;
IGraphicsFill.prototype = {
	
};
IGraphicsFill.prototype.__class__ = IGraphicsFill.prototype.constructor = $hxClasses["openfl.display.IGraphicsFill"] = IGraphicsFill;

// Init



// Statics




// Export

exports.default = IGraphicsFill;